import { render, staticRenderFns } from "./OrganizationList.vue?vue&type=template&id=4141d930&scoped=true&"
import script from "./OrganizationList.vue?vue&type=script&lang=js&"
export * from "./OrganizationList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationList.vue?vue&type=style&index=0&id=4141d930&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4141d930",
  null
  
)

export default component.exports